<template>
  <b-card class="creditcard">
    <p class="m-1">
      <small>{{ resources.component.creditCard.cardNumber }}</small> <br />
      {{ card.number }}
    </p>
    <div class="flex m-1">
      <div>
        <small>{{ resources.component.creditCard.validate }}</small> <br />
        {{ card.validate }}
      </div>
      <div class="text-center">
        <small>{{ resources.component.creditCard.verifiedCode }}</small> <br />
        {{ card.cvv }}
      </div>
    </div>
    <div class="flex m-1 mt-2">
      <b>{{ card.name }}</b>
      <div class="brand" :class="card.brand.toLowerCase()"></div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  card: {
    type: Object,
    default: () => ({
      number: '**** **** **** 0000'.replace(/\*/g, '•'),
      cvv: '***'.replace(/\*/g, '•'),
      name: 'João da Silva',
      validate: '01/12',
      brand: 'visa',
    }),
  },
}
export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.creditcard {
  background-color: map-get($theme-colors, 'purple07');
  background-image: url('../../assets/payment/vector.svg');
  background-repeat: no-repeat;
  background-size: 80%;
  background-position: center;
  color: map-get($theme-colors, 'purple03');
  display: flex;
  font-weight: 500;
  height: 185px;
  width: 300px;

  @media (max-width: '425px') {
    padding: 1rem;
    width: 95%;
  }

  small {
    font-weight: 500;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .brand {
    height: 30px;
    width: 50px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.mastercard {
      background-image: url('../../assets/payment/master.svg');
    }

    &.visa {
      background-image: url('../../assets/payment/visa.svg');
    }
  }
}
</style>
